import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";

interface RoutineDeleteDialogProps {
  open: boolean;
  routine: {
    id: number;
    description: string;
  } | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const RoutineDeleteDialog = ({
  open,
  routine,
  isDeleting,
  onCancel,
  onConfirm,
}: RoutineDeleteDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Delete Routine</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this routine?
        </DialogContentText>
        {routine && (
          <Box
            sx={{
              mt: 2,
              p: 1.5,
              bgcolor: "grey.100",
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" fontWeight={600}>
              {routine.description}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onCancel} variant="outlined" disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isDeleting}
        >
          {isDeleting ? <CircularProgress size={20} /> : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RoutineDeleteDialog;
